<div
  class="atn-detail-title-editor"
  title="Click to edit title"
>
  <!-- NOTE: Convert undefined to null to prevent input from displaying 'undefined' as text -->
  <input
    type="text"
    placeholder="Click to add title..."
    [value]="valueSg() ?? null"
    (input)="onInputChange($event)"
    (keydown)="onKeyDown($event)"
    aria-label="Edit title"
  />
</div>
